<template>
  <button class="button" :class="type + '-btn'" @click="$emit('btnEvent')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: String
  }
}
</script>

<style lang="scss" scoped>
.button {
  color: #fff;
  text-transform: uppercase;
  @include flexrc;
  @include px2res(width, 237);
  @include px2res(height, 87);
  @include px2res(font-size, 34);
  -webkit-text-stroke: 1px rgba(0, 0, 0, .3);
  transition: all .3s cubic-bezier(0.0,0.0,0.2,1);
}
.button:disabled {
  filter: grayscale(100%)
}
.buy-btn, .comfirm-btn {
  @include px2res(width, 573);
  @include px2res(height, 133);
  @include px2res(font-size, 60);
  color:rgba(61, 11, 0, 1);
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Button.vue